import { render, staticRenderFns } from "./BaseInputModal.vue?vue&type=template&id=1c60648a"
import script from "./BaseInputModal.vue?vue&type=script&lang=js"
export * from "./BaseInputModal.vue?vue&type=script&lang=js"
import style0 from "./BaseInputModal.vue?vue&type=style&index=0&id=1c60648a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports